import OnboardingSlide from './OnboardingSlide';
import ReadyDemoAnimation from './ReadyDemoAnimation';

export default function SlideReady() {
  return (
    <OnboardingSlide illustration={<ReadyDemoAnimation />} title="You Are Ready!">
      <p>Start your shift and let Sawtna handle the documentation.</p>
      <p className="font-medium text-gray-700">Quick recap:</p>
      <ol className="list-inside list-decimal space-y-1 text-xs">
        <li>Open <strong>Patients</strong> — favorite and tap a patient for details.</li>
        <li><strong>Hold the mic</strong> to document — release when done.</li>
        <li><strong>Review</strong> each note, then save or discard.</li>
        <li>Complete <strong>tasks</strong> and check the <strong>flow sheet</strong>.</li>
        <li>Use the <strong>tabs</strong> to view notes, vitals, meds, and reports.</li>
        <li><strong>End shift</strong> from your profile to generate handover.</li>
      </ol>
      <p className="text-xs text-gray-500">
        Need help later? Profile → View Tutorial Again.
      </p>
    </OnboardingSlide>
  );
}
